<template>
    <span
        class="border"
        :style="{ 'border-radius': radius ? `${radius}px` : null }"
    >
        <svg
            class="border-main"
            :style="{ 'border-radius': radius ? `${radius}px` : null }"
        >
            <rect
                :class="['border-stroke', { animate }]"
                :rx="_radius"
                :x="offset"
                :y="offset"
                width="100%"
                height="100%"
                :style="{
                    'stroke-dasharray': dashArray.toString(),
                    'stroke-dashoffset': `${dashOffset}px`,
                    'stroke-width': width * 2,
                    'animation-duration': `${duration}ms`,
                    width: rectDimensions,
                    height: rectDimensions,
                }"
            />
        </svg>
    </span>
</template>

<script>
import { sum } from '@/helpers/utilities';

const DEFAULT_DASH_ARRAY = [6, 6];
const DEFAULT_STROKE_WIDTH = 1;
const DEFAULT_BORDER_RADIUS = 16;
const DEFAULT_PLAY_DURATION = 1000;

export default {
    name: 'Border',
    props: {
        dashed: { type: [Boolean, Array], default: false },
        width: { type: Number, default: DEFAULT_STROKE_WIDTH },
        radius: { type: Number, default: DEFAULT_BORDER_RADIUS },

        circle: { type: Boolean, default: false },
        animate: { type: Boolean, default: false },
        duration: { type: Number, default: DEFAULT_PLAY_DURATION }
    },
    computed: {
        offset() {
            return this.circle ? '1' : null;
        },
        rectDimensions() {
            return this.circle ? 'calc(100% - 2px)' : null;
        },
        _radius() {
            if (this.circle) return '100%';
            return this.radius;
        },
        dashArray() {
            return {
                boolean: this.dashed ? DEFAULT_DASH_ARRAY : [0, 0],
                object: this.dashed
            }[typeof this.dashed];
        },
        dashOffset() {
            return sum(this.dashArray);
        }
    }
};
</script>

<style lang="less">
@keyframes march {
    to { stroke-dashoffset: 0; }
}
</style>

<style lang="less">
.border {
    position: relative;
    display: block;
    pointer-events: none;
}
.border-main {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: scale(1);
}
.border-stroke {
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    animation-name: march;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-play-state: paused;
    &.animate { animation-play-state: running; }
}
</style>
